import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ArchiveIconComponent, RestoreIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-archive-confirmation-popup',
  imports: [TranslocoPipe, RestoreIconComponent, ArchiveIconComponent],
  templateUrl: './archive-confirmation-popup.component.html',
  styleUrl: './archive-confirmation-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ArchiveConfirmationPopupComponent {
  type = input<'archive' | 'restore'>('archive');
  isLoading = input<boolean>(false);
  titleKey = input<string>('');
  descriptionKey = input<string>('');
  highlightedDescriptionKey = input<string>('');
  confirmButtonKey = input<string>('');
  cancelButtonKey = input<string>('');

  confirm = output<void>();
  closeModal = output<void>();

  get iconBackgroundClass(): string {
    return this.type() === 'archive' ? 'bg-destructive-50' : 'bg-primary-50';
  }

  get confirmButtonClass(): string {
    return this.type() === 'archive' ? 'bg-destructive-500' : 'bg-primary-500';
  }

  get highlightedTextClass(): string {
    return this.type() === 'archive'
      ? 'text-destructive-500'
      : 'text-primary-500';
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
